module.exports = __webpack_public_path__ + "img/store_inactive.3fed6215.png";